module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-form', {
    ref: "licenseeForm",
    attrs: {
      "label-position": "top"
    },
    model: {
      value: (_vm.telco),
      callback: function($$v) {
        _vm.telco = $$v
      },
      expression: "telco"
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 24
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Sharer"
    }
  }, [_c('strong', [_vm._v(_vm._s(_vm.sharerName))])])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Telco Site ID",
      "required": ""
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Site ID",
      "disabled": _vm.stepSaved || _vm.canEdit
    },
    model: {
      value: (_vm.telco.telcoSiteId),
      callback: function($$v) {
        _vm.$set(_vm.telco, "telcoSiteId", $$v)
      },
      expression: "telco.telcoSiteId"
    }
  })], 1)], 1)], 1), _vm._v(" "), (!_vm.canEdit) ? _c('section', [_c('el-row', {
    attrs: {
      "gutter": 12
    }
  }, [_c('el-col', {
    attrs: {
      "md": 24,
      "lg": 12
    }
  }, [_c('select-service-type', {
    attrs: {
      "disabled": _vm.stepSaved || _vm.canEdit
    },
    model: {
      value: (_vm.telco.serviceType),
      callback: function($$v) {
        _vm.$set(_vm.telco, "serviceType", $$v)
      },
      expression: "telco.serviceType"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "md": 24,
      "lg": 12
    }
  }, [_c('select-spectrum', {
    attrs: {
      "disabled": _vm.stepSaved || _vm.canEdit
    },
    model: {
      value: (_vm.telco.spectrumBand),
      callback: function($$v) {
        _vm.$set(_vm.telco, "spectrumBand", $$v)
      },
      expression: "telco.spectrumBand"
    }
  })], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 12
    }
  }, [_c('el-col', {
    attrs: {
      "md": 24,
      "lg": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Handover Date",
      "required": ""
    }
  }, [_c('el-date-picker', {
    attrs: {
      "format": _vm.format,
      "disabled": _vm.stepSaved || _vm.canEdit
    },
    model: {
      value: (_vm.telco.handover),
      callback: function($$v) {
        _vm.$set(_vm.telco, "handover", $$v)
      },
      expression: "telco.handover"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "md": 24,
      "lg": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Commencement Date",
      "required": ""
    }
  }, [_c('el-date-picker', {
    attrs: {
      "format": _vm.format,
      "disabled": _vm.stepSaved || _vm.canEdit
    },
    model: {
      value: (_vm.telco.started),
      callback: function($$v) {
        _vm.$set(_vm.telco, "started", $$v)
      },
      expression: "telco.started"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "md": 24,
      "lg": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "On Air Date"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "format": _vm.format,
      "disabled": _vm.stepSaved || _vm.canEdit
    },
    model: {
      value: (_vm.telco.onAir),
      callback: function($$v) {
        _vm.$set(_vm.telco, "onAir", $$v)
      },
      expression: "telco.onAir"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "md": 24,
      "lg": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Expiry Date"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "format": _vm.format,
      "label": "Contract End",
      "disabled": ""
    },
    model: {
      value: (_vm.expiryDate),
      callback: function($$v) {
        _vm.expiryDate = $$v
      },
      expression: "expiryDate"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 8
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "capex",
      "label": "CAPEX"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "placeholder": "CAPEX",
      "disabled": _vm.stepSaved || _vm.canEdit
    },
    model: {
      value: (_vm.telco.capex),
      callback: function($$v) {
        _vm.$set(_vm.telco, "capex", $$v)
      },
      expression: "telco.capex"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "OPEX"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "placeholder": "OPEX",
      "disabled": _vm.stepSaved || _vm.canEdit
    },
    model: {
      value: (_vm.telco.opex),
      callback: function($$v) {
        _vm.$set(_vm.telco, "opex", $$v)
      },
      expression: "telco.opex"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 8
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', [_vm._v("\n            Cabins  "), _c('el-input-number', {
    attrs: {
      "min": 0,
      "max": 5,
      "size": "mini",
      "disabled": _vm.stepSaved || _vm.canEdit
    },
    model: {
      value: (_vm.telco.cabin),
      callback: function($$v) {
        _vm.$set(_vm.telco, "cabin", $$v)
      },
      expression: "telco.cabin"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('check-box', {
    attrs: {
      "disabled": _vm.stepSaved || _vm.canEdit
    },
    model: {
      value: (_vm.telco.ownMeter),
      callback: function($$v) {
        _vm.$set(_vm.telco, "ownMeter", $$v)
      },
      expression: "telco.ownMeter"
    }
  }, [_vm._v(_vm._s('Own  ' + _vm.utilLabel + ' Meter'))])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Tenor (years)"
    }
  }, [_c('el-slider', {
    attrs: {
      "min": 1,
      "max": 20,
      "show-stops": "",
      "show-input": "",
      "disabled": _vm.stepSaved || _vm.canEdit
    },
    model: {
      value: (_vm.tenor),
      callback: function($$v) {
        _vm.tenor = $$v
      },
      expression: "tenor"
    }
  })], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "align": "middle"
    }
  }, [_c('el-button', {
    attrs: {
      "plain": true,
      "type": "success",
      "icon": "fa fa-check",
      "disabled": _vm.stepSaved || _vm.canEdit
    },
    on: {
      "click": _vm.onSave
    }
  }, [_vm._v("Save")]), _vm._v(" "), (_vm.isSuper()) ? _c('el-button', {
    attrs: {
      "plain": true,
      "type": "error",
      "icon": "fa fa-edit"
    },
    on: {
      "click": function($event) {
        _vm.stepSaved = false
      }
    }
  }) : _vm._e()], 1)], 1)], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6f38ad5a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/requests/LicenseeForm.vue
// module id = 1630
// module chunks = 0